module.exports = __webpack_public_path__ + "img/no-access-from-mobile.865a041a.png";